import * as React from 'react';
import { connect } from 'react-redux';
import * as Models from './models/index';
import * as Components from './components/index';

import './layout.small.scss';

interface StateProps {
	messages: Models.CorporateMessage[];
}
interface OwnState {
	showMessages: boolean;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	messages: state.messages.messages,
});

export default connect(mapStateToProps)(
	class Index extends React.Component<StateProps & OwnState, any> {
		render() {
			return (
				<Components.LayoutBlock className='app-host app-small full-absolute' fill>
					{this.props.showMessages ? (
						<Components.LayoutBlock className='layout-top-pane'>
							<Components.Button>
								<Components.Label>
									<Components.Icon icon='message' /> {this.props.messages.length} Announcements
								</Components.Label>
							</Components.Button>
						</Components.LayoutBlock>
					) : null}

					<Components.LayoutBlock className='router' fill>
						{this.props.children}
					</Components.LayoutBlock>
				</Components.LayoutBlock>
			);
		}
	}
);
